import {
  ADD_FAVORITE_REQUEST_ERROR,
  ADD_FAVORITE_REQUEST_INIT,
  ADD_FAVORITE_REQUEST_SUCCESS, DELETE_FAVORITE_REQUEST_ERROR,
  DELETE_FAVORITE_REQUEST_INIT,
  DELETE_FAVORITE_REQUEST_SUCCESS,
  GET_FAVORITE_REQUEST_ERROR,
  GET_FAVORITE_REQUEST_INIT,
  GET_FAVORITE_REQUEST_SUCCESS,
} from 'containers/Player/actions/favorite/constants';

const initialState = {
  items: [],
  loading: false,
  error: null,
};

const Favorite = (state = initialState, action) => {
  switch (action.type) {
    case GET_FAVORITE_REQUEST_INIT:
      return {
        items: [...state.items],
        loading: true,
        error: null,
      };
    case GET_FAVORITE_REQUEST_SUCCESS:
      return {
        items: [...action.items],
        loading: false,
        error: null,
      };
    case GET_FAVORITE_REQUEST_ERROR:
      return {
        items: [...state.items],
        loading: false,
        error: action.error,
      };
    case ADD_FAVORITE_REQUEST_INIT:
      return {
        items: [...state.items],
        loading: true,
        error: null,
      };
    case ADD_FAVORITE_REQUEST_SUCCESS:
      return {
        items: [...state.items],
        loading: false,
        error: null,
      };
    case ADD_FAVORITE_REQUEST_ERROR:
      return {
        items: [...state.items],
        loading: false,
        error: null,
      };
    case DELETE_FAVORITE_REQUEST_INIT:
      return {
        items: [...state.items],
        loading: true,
        error: null,
      };
    case DELETE_FAVORITE_REQUEST_SUCCESS:
      return {
        items: [...state.items],
        loading: false,
        error: null,
      };
    case DELETE_FAVORITE_REQUEST_ERROR:
      return {
        items: [...state.items],
        loading: false,
        error: null,
      };
    default:
      return state;
  }
};

export default Favorite;
